// Logout: revoke the refresh token server-side (best effort), clear local state, leave for /sign-in.

import { OAUTH_CLIENT_ID, OAUTH_REFRESH_TOKEN } from 'services/auth/constants';
import { clearSession } from 'services/auth/session';
import { revokeToken } from 'services/auth/token-endpoint';
import { getMemoryToken, withRefreshLock } from 'services/auth/token-store';

const SIGN_IN_PATH = '/sign-in';

// A revoke failure must never keep the user signed in: it is swallowed and local state is cleared anyway.
const revokeBestEffort = async (): Promise<void> => {
  const clientId = localStorage.getItem(OAUTH_CLIENT_ID);
  const token = localStorage.getItem(OAUTH_REFRESH_TOKEN) ?? getMemoryToken();
  if (!clientId || !token) return;
  try {
    await revokeToken({ clientId, token });
  } catch {
    // Server-side revocation is best effort; the token expires on its own.
  }
};

// Runs after any in-flight refresh settled; clearSession bumps the generation so a later refresh never persists.
export const logout = async (): Promise<void> => {
  await withRefreshLock(async () => {
    await revokeBestEffort();
    clearSession();
  });
  window.location.replace(SIGN_IN_PATH);
};
